import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";

const CourseReason = ({ reason, label }) => (
  <Typography
    className="elipssis"
    variant="body1"
    sx={{ whiteSpace: "pre-line" }}
  >
    {label}
    <Typography component="span" title={reason} variant="body1">
      {reason}
    </Typography>
  </Typography>
);

export default CourseReason;
